import types from "./types";

const INITIAL_STATE = {
	client_evaluation: null,
	client_evaluationError: null,
	client_evaluationLoading: false,

	//create
	createclient_evaluation: null,
	createclient_evaluationError: null,
	createclient_evaluationLoading: false,

	//update
	updateclient_evaluation: null,
	updateclient_evaluationError: null,
	updateclient_evaluationLoading: false,

	//delete
	deleteclient_evaluation: null,
	deleteclient_evaluationError: null,
	deleteclient_evaluationLoading: false,

	//single item

	singleItem: null,
};

const ClientEvaluationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_CLIENT_EVALUATION_START:
			return {
				...state,
				client_evaluation: null,
				client_evaluationError: null,
				client_evaluationLoading: true,
			};
		case types.GET_CLIENT_EVALUATION_SUCCESS:
			return {
				...state,
				client_evaluation: action.payload,
				client_evaluationLoading: false,
			};
		case types.GET_CLIENT_EVALUATION_ERROR:
			return {
				...state,
				client_evaluationError: action.payload,
				client_evaluationLoading: false,
			};
		case types.GET_CLIENT_EVALUATION_RESET:
			return {
				...state,
				client_evaluationError: null,
				client_evaluationLoading: false,
			};
		//create

		case types.CREATE_CLIENT_EVALUATION_START:
			return {
				...state,
				createclient_evaluation: null,
				createclient_evaluationError: null,
				createclient_evaluationLoading: true,
			};
		case types.CREATE_CLIENT_EVALUATION_SUCCESS:
			return {
				...state,
				createclient_evaluation: action.payload,
				createclient_evaluationLoading: false,
			};
		case types.CREATE_CLIENT_EVALUATION_ERROR:
			return {
				...state,
				createclient_evaluationError: action.payload,
				createclient_evaluationLoading: false,
			};
		case types.CREATE_CLIENT_EVALUATION_RESET:
			return {
				...state,
				createclient_evaluationError: null,
				createclient_evaluationLoading: false,
			};
		//delete

		case types.DELETE_CLIENT_EVALUATION_START:
			return {
				...state,
				deleteclient_evaluation: null,
				deleteclient_evaluationError: null,
				deleteclient_evaluationLoading: true,
			};
		case types.DELETE_CLIENT_EVALUATION_SUCCESS:
			return {
				...state,
				deleteclient_evaluation: action.payload,
				deleteclient_evaluationLoading: false,
			};
		case types.DELETE_CLIENT_EVALUATION_ERROR:
			return {
				...state,
				deleteclient_evaluationError: action.payload,
				deleteclient_evaluationLoading: false,
			};
		case types.DELETE_CLIENT_EVALUATION_RESET:
			return {
				...state,
				deleteclient_evaluation: null,
				deleteclient_evaluationError: null,
				deleteclient_evaluationLoading: false,
			};

		//update
		case types.UPDATE_CLIENT_EVALUATION_START:
			return {
				...state,
				updateclient_evaluation: null,
				updateclient_evaluationError: null,
				updateclient_evaluationLoading: true,
			};
		case types.UPDATE_CLIENT_EVALUATION_SUCCESS:
			return {
				...state,
				updateclient_evaluation: action.payload,
				updateclient_evaluationLoading: false,
			};
		case types.UPDATE_CLIENT_EVALUATION_ERROR:
			return {
				...state,
				updateclient_evaluationError: action.payload,
				updateclient_evaluationLoading: false,
			};
		case types.UPDATE_CLIENT_EVALUATION_RESET:
			return {
				...state,
				updateclient_evaluation: null,
				updateclient_evaluationError: null,
				updateclient_evaluationLoading: false,
			};
		//singleItem
		// case types.SINGLE_CLIENT_EVALUATION_START:
		// 	return {
		// 		...state,
		// 		updateclient_evaluation: null,
		// 		updateclient_evaluationError: null,
		// 		updateclient_evaluationLoading: true,
		// 	};
		// case types.SINGLE_CLIENT_EVALUATION_SUCCESS:
		// 	return {
		// 		...state,
		// 		updateclient_evaluation: action.payload,
		// 		updateclient_evaluationLoading: false,
		// 	};
		// case types.SINGLE_CLIENT_EVALUATION_ERROR:
		// 	return {
		// 		...state,
		// 		updateclient_evaluationError: action.payload,
		// 		updateclient_evaluationLoading: false,
		// 	};
		// case types.SINGLE_CLIENT_EVALUATION_RESET:
		// 	return {
		// 		...state,
		// 		updateclient_evaluationError: null,
		// 		updateclient_evaluationLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default ClientEvaluationReducer;
